import React, { forwardRef } from 'react';

import CustomLink from './Link';
import { Navbar, className } from 'react-bootstrap-components';

// import style from './style.module.scss';

export default forwardRef(function Header(
    {
        title,
        hideOnScroll = false,
        defaultIsFixed = false,
        isFixed = false,
        isDark = false,
        isTransparent = false,
        navGroups = [],
        dropdownClassName = null,
        dropdownCollapseClassName = null,
        wrapperClassName = null,
        durationCollapse = null,
        navbarExtraContent = null,
        // logo = null,
        // logoWhite = null,
        logoDom = null,
        customTogglerIcon = null,
        customTogglerIconOpen = null,
        customToggler = null,
        className: cls = null,
        dropdownOverlay,
        onDropdownOpen,
        onDropdownClose,
        NavbarBrandTag,
        navbarBrandHref,
        navbarRef,
        blockScrollStyle,
    },
    ref,
) {
    return (
        <header {...className(`${isDark ? 'bg-dark' : ''}`)} ref={ref}>
            <Navbar
                Tag={CustomLink}
                scrollDark={isDark}
                NavbarBrandTag={NavbarBrandTag}
                isFixed={isFixed || defaultIsFixed}
                isTransparent={isTransparent}
                dark={isDark}
                hideOnScroll={hideOnScroll}
                href={navbarBrandHref ? navbarBrandHref : '/'}
                scheme="gatsby"
                logoDom={logoDom}
                dropdownClassName={dropdownClassName}
                dropdownCollapseClassName={dropdownCollapseClassName}
                dropdownOverlay={dropdownOverlay}
                onDropdownOpen={onDropdownOpen}
                onDropdownClose={onDropdownClose}
                brandParams={{
                    'aria-current': 'page',
                    'aria-label': title,
                }}
                extraClass={`${cls ? cls : ''}`}
                blockScrollStyle={blockScrollStyle}
                {...(wrapperClassName && {
                    wrapperClassName: wrapperClassName,
                })}
                {...(navbarExtraContent && { navbarExtraContent })}
                {...{ durationCollapse }}
                {...{ customTogglerIcon }}
                {...{ customTogglerIconOpen }}
                {...{ customToggler }}
                {...(navbarRef && { ref: navbarRef })}
                navs={navGroups}
            />
        </header>
    );
});

// DEPC

// logo={logo ? logo : data.logo ? data.logo.publicURL : null}
//                 logoNavbarShown={
//                     logoWhite
//                         ? logoWhite
//                         : data.logoWhite
//                         ? data.logoWhite.publicURL
//                         : null
//                 }
//                 logoAlt={title}
